<div class="container fifth-container mt-100px">
  <div class="fifth-section-vector-wrapper">
    <img src="assets/homepage/digital-business-card-sharing/phone-background.png" alt="fifth section" id="fifth-section-vector">
  </div>

  <div class="container-title-div">
    <span class="fifth-container-title" [ngClass]="{'fifth-container-title-am': currentLang === Language.HY, 'fifth-container-title-ru':currentLang === Language.RU}">{{'home-page-content.your_card' | translate}}</span>
    <span class="fifth-container-subtitle mt-4">{{'home-page-content.your_card_text' | translate}}</span>
  </div>

  <div class="row mt-5">
    <div class="col-6">
      <img src="assets/homepage/digital-business-card-sharing/phone.png" alt="fifth section img" class="i-width-100">
    </div>
    <div class="flex-direction-column fifth-container-links-div mt-3 col-6">
      @for (link of links; track link) {
        <div class="fifth-container-column">
          <img [src]="link.image" alt="click svg">
          <div class="flex-direction-column fifth-container-column-text">
            <span class="fifth-container-column-title">{{link.title | translate}}</span>
            <span class="fifth-container-column-subtitle">{{link.subtitle | translate}}</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<section class="section-wrapper-mb fifth-container-mb mt-100px">
  <div class="flex-direction-column">
    <div class="container-title-div">
      <span class="fifth-container-title">
        {{'home-page-content.your_card' | translate}}
      </span>
      <span class="fifth-container-subtitle mt-4" [ngClass]="{'fifth-container-subtitle-mb mt-4': currentLang === Language.HY}">
        {{'home-page-content.your_card_text' | translate}}
      </span>
    </div>
    <div class="sharing-image-wrapper-mb">
      <img src="/assets/homepage/digital-business-card-sharing/phone.png" alt="sharing image mobile">
    </div>

    <div class="flex-direction-column fifth-container-links-div-mb mt-3">
      @for (link of links; track link) {
        <div class="fifth-container-column align-items-start">
          <img [src]="link.image" alt="click svg" class="icon-max-width">
          <div class="flex-direction-column fifth-container-column-text">
            <span class="fifth-container-column-title">{{link.title | translate}}</span>
            <span class="fifth-container-column-subtitle">{{link.subtitle | translate}}</span>
          </div>
        </div>
      }
    </div>
  </div>
</section>
